export default __webpack_public_path__ + "static/media/MongoDBAtlas.a4f56329.svg";